import { Link, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import style from "../../assets/scss/sub/understanding.module.scss";
import { FloatingBtn } from "../common/button/FloatingBtn";
import { useTranslation } from "react-i18next";
import { useFooter, useLanguage, useUserAgent } from "../../hooks/hooks";

export function Understanding() {
  const { t } = useTranslation(["subUnderstanding"]);
  const { setShowFooter } = useFooter();
  const location = useLocation();
  const [tabMenu, setTabMenu] = useState("");

  const { isTablet } = useUserAgent();
  const { isKorean } = useLanguage();

  useEffect(() => {
    document.title = `${t("title")} | ${process.env.REACT_APP_TITLE}`;
  }, [t]);

  useEffect(() => {
    const pathname = location.pathname;
    const pathnameArr = pathname.split("/");
    const lastPath = pathnameArr[pathnameArr.length - 1];
    setTabMenu(lastPath);
  }, [location]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowFooter(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className={style.understanding}>
      <FloatingBtn />
      <div className={style.title}>
        <span className={`${style.text} ${style.understandingTitle} ${!isKorean & isTablet ? style.tabMargin : null}`}>
          {t("title")}
        </span>
      </div>
      <nav className={style.nav}>
        <ul className={style.list}>
          <li className={`${style.menuItem}`}>
            <Link className={`${tabMenu === "dcas" ? style.active : ""}`} to="/understanding/dcas">
              {t("understandingTab.line1")}
              <br />
              {t("understandingTab.line2")}
            </Link>
          </li>
          <li className={`${style.menuItem}`}>
            <Link className={`${tabMenu === "history" ? style.active : ""}`} to="/understanding/history">
              {t("historyTab")}
            </Link>
          </li>
          <li className={`${style.menuItem}`}>
            <Link className={`${tabMenu === "academic-basis" ? style.active : ""}`} to="/understanding/academic-basis">
              {t("academicBasisTab")}
            </Link>
          </li>
        </ul>
      </nav>
      <Outlet />
    </main>
  );
}
